import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ProfileService } from 'src/app/pages/app/profile/services/profile.service';
import { AuthService, RudderStack } from 'src/app/services';

@Component({
	selector: 'app-logout-tab',
	templateUrl: './logout-tab.component.html',
	styleUrls: ['./logout-tab.component.scss'],
})
export class LogoutTabComponent implements OnInit {
	profile$: Observable<any> = this.profileService.loadProfileData();

	constructor(
		private profileService: ProfileService,
		public authService: AuthService,
		public popoverController: PopoverController,
		private router: Router,
		private rudderStack: RudderStack,
	) {
		// test
	}

	public ngOnInit() {
		// test
	}

	public logout() {
		this.authService
			.signOut()
			.then(data => {
				this.popoverController.dismiss();
				// comment
			})
			.catch(() => {
				// comment
			});
	}

	gotoProfile(profileId) {
		this.popoverController.dismiss();
		this.rudderStack.log({
			type: 'profile_view_own',
			profileId: profileId,
		});
		this.router.navigate([`/app/profile/view/${profileId}`]);
	}
}
